import { render, staticRenderFns } from "./templates.vue?vue&type=template&id=1759c57c&"
import script from "./templates.vue?vue&type=script&lang=js&"
export * from "./templates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports